import type { FeatureLike } from 'ol/Feature.js';
import { Fill, Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';

/**
 * Styles the handles use to move/resize
 */
export function getMoveHandleStyle(feature: FeatureLike): Style {
  const type = feature.get('type') as string | undefined;

  let fillColor = 'white';

  if (type === 'radius-handle') {
    fillColor = 'white';
  }

  return new Style({
    image: new CircleStyle({
      radius: 8,
      fill: new Fill({ color: fillColor }),
      stroke: new Stroke({ color: 'black', width: 2 }),
    }),
  });
}
